import React from 'react';
import {
  Show,
  SimpleShowLayout,
  TextField,
  FunctionField,
  useRecordContext,
  useRefresh,
  useGetOne,
} from 'react-admin';
import { leadImportFields } from '../leadImports.model';
import { StatusChip, DateTimeField } from './field';
import RealTimeImportDetails from './RealTimeImportDetails.component';
import { USERS_RESOURCE_NAME } from '../../users/user.dataProvider';
import logger from '../../utils/logger';

const DebugRecord = () => {
  const record = useRecordContext();
  const refresh = useRefresh();

  // Force refresh when component mounts to ensure fresh data
  React.useEffect(() => {

    refresh();
  }, []);

  React.useEffect(() => {
    if (record) {
      logger.log('Lead Import Show - Record data:', record);
      logger.log('Batch ID:', record[leadImportFields.batchId]);
      logger.log('Status:', record[leadImportFields.status]);
      logger.log('Stats:', record[leadImportFields.stats]);
    }
  }, [record]);

  return null;
};

const TriggeredByUserName = ({ uploaderId }: { uploaderId?: number }) => {
  const { data: user, isLoading, error } = useGetOne(
    USERS_RESOURCE_NAME,
    { id: uploaderId },
    { enabled: !!uploaderId }
  );

  if (!uploaderId) return <span>Unknown</span>;
  if (isLoading) return <span>Loading...</span>;
  if (error) return <span>User {uploaderId}</span>;

  const fullName = user
    ? `${user.first_name || ''} ${user.last_name || ''}`.trim()
    : `User ${uploaderId}`;

  return <span>{fullName || `User ${uploaderId}`}</span>;
};



export const LeadImportShow = () => (
  <Show title="Lead Import Details">
    <SimpleShowLayout>
      <DebugRecord />
      <TextField source={leadImportFields.batchId} label="Batch ID" />
      <TextField source={leadImportFields.filename} label="Filename" />
      <TextField
        source={leadImportFields.sourceOrg}
        label="Source Organization"
      />
      <StatusChip label="Status" />
      <FunctionField
        label="Triggered By"
        render={(record) => <TriggeredByUserName uploaderId={record?.[leadImportFields.triggeredBy]} />}
      />
      <DateTimeField source={leadImportFields.createdAt} label="Upload Date" />
      <DateTimeField source={leadImportFields.updatedAt} label="Last Updated" />
      <FunctionField label="" render={() => <RealTimeImportDetails />} />
    </SimpleShowLayout>
  </Show>
);

export default LeadImportShow;
